export interface UseGeoAvailabilityReturn {
  countryCode: Readonly<Ref<string | undefined>>
  ip: Readonly<Ref<string | undefined>>
  isAvailable: Readonly<Ref<boolean>>
  isReady: Readonly<Ref<boolean>>
}

export function useGeoAvailability(): UseGeoAvailabilityReturn {
  const { countryCode, ip, isAvailable, isReady } = useNuxtApp().$geo
  return { countryCode, ip, isAvailable, isReady }
}
